export default __webpack_public_path__ + "static/media/NoClosed.72f5ea4d.jpg";